import * as React from 'react';
import { useSlate } from 'slate-react';
import View from '@sdk/components/primitives/View';

import { toggleBlock, isBlockActive } from '../helpers/utils';
import { CustomElementTypes } from '../types';

import TextEditToolbarButton from './TextEditToolbarButton';

type Props = {
  format: CustomElementTypes;
  icon: JSX.Element;
  activeIcon: JSX.Element;
};

const MarkBlockIconButton: React.FC<React.PropsWithChildren<Props>> = ({
  icon,
  activeIcon,
  format,
}) => {
  const editor = useSlate();
  const isActive = isBlockActive(editor, format);

  return (
    <View>
      <TextEditToolbarButton
        isActive={false}
        onMouseDown={(): void => toggleBlock(editor, format)}
        mRight={3}>
        {isActive ? activeIcon : icon}
      </TextEditToolbarButton>
    </View>
  );
};

export default MarkBlockIconButton;
